<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetPripeljaniPrijatelji"
                           v-on:osvezitevIzbranSap="SetAmbasadorskaStevilka"
                           :selectorPermissions="selectorPermissions"
                           :disabled="nalaganjePripeljanihPrijateljev"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <div>
            <div>
              <p class="naslov">
                T-2 AMBASADOR
              </p>
            </div>
          </div>
          <div v-loading="nalaganjePripeljanihPrijateljev">
            <div v-if="seznamPripeljanihPrijateljev.length > 0">
              <div style="padding-top: 10px;">
                <div class="postavitev-vsebine">
                  <p class="primarna-barva-pisave">
                    Hvala.<br/>
                    Z vašo pomočjo je družba zadovoljnih T-2 naročnikov iz dneva v dan večja.<br/>
                    In ne pozabite, število pripeljanih prijateljev je neomejeno. Več prijateljev
                    pripeljete, nižji bo vaš mesečni račun.
                  </p>
                  <div style="padding-top: 30px; padding-bottom: 20px">
                    <div v-show="prikazTabele === '1'">
                      <el-table
                        max-height="400"
                        :data="seznamPripeljanihPrijateljev"
                        v-loading="nalaganjePripeljanihPrijateljev">
                        <el-table-column
                          prop="imePriimek"
                          label="Ime pripeljanega prijatelja"
                          width="400px">
                        </el-table-column>
                        <el-table-column
                          prop="datum"
                          label="Datum pristopa"
                          width="200px">
                        </el-table-column>
                      </el-table>
                    </div>
                    <div v-show="prikazTabele === '0'">
                      <el-table
                        :row-key="row => row.imePriimek"
                        :expand-row-keys="expandRowKeys"
                        :data="seznamPripeljanihPrijateljev"
                        @expand-change="PripeljaniPrijatleji">
                        <el-table-column
                          prop="imePriimek"
                          label="Ime pripeljanega prijatelja">
                        </el-table-column>
                        <el-table-column type="expand">
                          <template slot-scope="props">
                            <div class="postavitev-podatkov-znotraj-tabele">
                              <p class="navadno-besedilo">
                                Datum pristopa: {{props.row.datum}}
                              </p>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </div>
                <div class="postavitev-ambasadorska-stevilka">
                  <div class="box-notranja-postavitev-ambasadorska-st">
                    <p class="izpis-sap">
                      <b>
                        {{ izbranSap }}
                      </b>
                    </p>
                    <p class="ambasador-tekst">
                      AMBASADORSKA ŠTEVILKA
                    </p>
                  </div>
                </div>
              </div>
              <div style="clear: both"/>
            </div>
            <div v-else-if="nalaganjePripeljanihPrijateljev === false">
              <div style="clear: both"/>
              <div class="odmik-vsebine-amabasador">
                <div class="postavitev-vsebine">
                  <p class="primarna-barva-pisave">
                  <b>Ste že izkoristili nagrado za priporočilo prijatelju? </b> Ne odlašajte – delite prednosti,
                    ki jih uživate kot naročnik T-2 in si prislužite dobropis pri naslednji položnici!
                    Za vsakega prijatelja, ki postane nov naročnik T-2 z 2-letno vezavo, <b>prejmete 10 €
                    dobropisa</b> pri sklenitvi mobilne naročnine ali kar <b>100 € dobropisa</b> pri sklenitvi fiksnega paketa.
                  </p>

                  <p class="primarna-barva-pisave">
                    In najboljše? Število prijateljev, ki jih lahko priporočite, je neomejeno – več jih povabite,
                    nižji bo vaš račun! Odkrijte vse podrobnosti o akciji <a style="cursor: pointer; color:#EF7D00" target="_blank" href="https://www.t-2.net/t-2-ambasador">Ambasador</a>.
                  </p>
                </div>
                <div class="postavitev-ambasadorska-stevilka">
                  <div class="box-notranja-postavitev-ambasadorska-st">
                    <p class="izpis-sap">
                      <b>
                        {{ izbranSap }}
                      </b>
                    </p>
                    <p class="ambasador-tekst">
                      AMBASADORSKA ŠTEVILKA
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="nalaganjePripeljanihPrijateljev === false">
              <hr class="hr-stil"/>
              <div style="padding-top: 30px; padding-bottom: 30px; clear: both;">
                <p class="podnaslov">
                  Kako postanete T-2 Ambasador? Zelo preprosto!
                </p>
                <div class="container-korakov" style="padding-top: 30px">
                  <div>
                    <div>
                      <p class="primarna-barva-pisave pisava-center">
                        <b>
                          1. korak
                        </b>
                      </p>
                    </div>
                    <div>
                      <p class="primarna-barva-pisave pisava-center">
                        Delite svojo ambasadorsko</br>
                        kodo s prijateljem.
                      </p>
                    </div>
                  </div>
                  <div>
                    <div>
                      <p class="primarna-barva-pisave pisava-center">
                        <b>
                          2. korak
                        </b>
                      </p>
                    </div>
                    <div>
                      <p class="primarna-barva-pisave pisava-center">
                        Prijatelj uporabi vašo</br>
                        ambasadorsko kodo ob sklenitvi </br>
                        nove naročniške pogodbe.
                      </p>
                    </div>
                    <div/>
                  </div>
                  <div>
                    <div>
                      <p class="primarna-barva-pisave pisava-center">
                        <b>
                          3. korak
                        </b>
                      </p>
                    </div>
                    <div>
                      <p class="primarna-barva-pisave pisava-center">
                        Ko prijatelju vklopimo storitve,</br>
                        vi prejmete bonus za znižanje</br>
                        mesečne naročnine za storitve.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {Button, Select, Option, CollapseItem, Collapse, Table, TableColumn} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {SirinaOkna} from '../../../../assets/js/globalne_funkcije/SirinaOkna'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import {PrenosDatoteke} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PrenosDatoteke'

export default {
  name: 'Ambasador',
  mixins: [SirinaOkna, StringConverter, PrenosDatoteke],
  data () {
    return {
      clientAgent: null,
      seznamNarocnin: [],
      idStranka: '',
      izbranSap: '',
      seznamPripeljanihPrijateljev: [],
      nalaganjePripeljanihPrijateljev: false,
      nalaganjeAmbasadorskeStevilke: false,
      expandRowKeys: [],
      mejnaSirinaTabela: 1000,
      prikazTabele: '1',
      selectorPermissions: ['STRANKE']
    }
  },
  watch: {
    orientacijaPrikazaTabele: function (val) {
      this.prikazTabele = val
    }
  },
  components: {
    'IzbirnikStranke': IzbirnikStranke,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
    this.clientAgent = new ClientAgent()
    this.nalaganjePripeljanihPrijateljev = true
  },
  methods: {
    SetAmbasadorskaStevilka (sap) {
      this.izbranSap = sap
    },
    PripeljaniPrijatleji (row, expandedRows) {
      const id = row.imePriimek
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    GetPripeljaniPrijatelji (idStranka) {
      if (idStranka !== '') {
        this.nalaganjePripeljanihPrijateljev = true
        let param = ['idStranka=' + idStranka]
        this.clientAgent.postWsRequest(this,
          '/stranka/ambasador/pripeljaniPrijatelji?',
          param,
          idStranka,
          'SetPripeljaniPrijatelji',
          '')
      }
    },
    SetPripeljaniPrijatelji (podatki, idStranka) {
      this.idStranka = idStranka
      this.seznamPripeljanihPrijateljev = podatki.data
      this.nalaganjePripeljanihPrijateljev = false
    },
    PridobiKupone () {
      let param = ['idStranka=' + this.idStranka]
      this.clientAgent.postWsRequest(this,
        'stranka/ambasador/generirajKupon?',
        param,
        null,
        'SetPridobitevKuponov',
        'ErrPridobitevKuponov')
    },
    SetPridobitevKuponov (podatki) {
      this.kuponi = podatki.data
      let doc = 'data:application/octet-stream;base64,' + this.kuponi[0].kupon
      this.PrenesiDatoteko(doc, this.kuponi[0].datoteka + '.' + this.kuponi[0].koncnica)
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno prenesen kupon.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrPridobitevKuponov () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Prosimo, poskusite kasneje.'
      this.ShowErrorMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../static/css/moj_profil/ambasador.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/Ambasador.vue